import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

const GET_ONBOARDING_CANDIDATE = gql`
    query OnboardingCandidate($uuid: ID!) {
        onboardingCandidate(uuid: $uuid) {
            uuid
            email
            firstname
            lastname
            gender
            birthdate
            phoneNumber
            addressLine1
            addressLine2
            zipCode
            city
            countryCode
            language
            cooptant
            resetComment
            socialSecurityNumber
            step
            onboardingCurrentMission {
                uuid
                jobTitle
                actualDailyRate
                workingDaysPerYear
                client
                missionDescription
                contactName
                contactEmail
                contactPhoneNumber
                desiredStartDate
            }
                unreadChatMessagesCount
                uploadedDocumentsCount
        }
    }
`;

const useOnboardingCandidate = (uuid) => {
    const { loading, error, data, refetch } = useQuery(GET_ONBOARDING_CANDIDATE, {
        variables: { uuid },
        skip: !uuid,
        fetchPolicy: 'network-only',
    });

    return {
        data: data?.onboardingCandidate,
        loading,
        error,
        refetch,
    };
};

export default useOnboardingCandidate;
